import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';

const Square = (props: SvgIconProps) => {
  return (
    <SvgIcon {...props}>
      <svg
        viewBox='0 0 24 24'
        fill='none'
        stroke='currentColor'
        strokeWidth='1.5'
        xmlns='http://www.w3.org/2000/svg'
      >
        <rect x='2' y='2' width='20' height='20' rx='6' />
      </svg>
    </SvgIcon>
  );
};

export default Square;
